<div class="login-container d-flex"  [ngStyle]="{ 'background-image': 'url(' + ('images/login-registration/login-background-image.jpg' | contentAssetImage) + ')' }">
  <!--Left Side-->
  <div class="left-side-panel">
    <img [src]="'images/login-registration/loginpagelogo.png' | contentAssetImage"
    alt="" />
  </div>
  <!--Right Side-->
  <div class="right-side-login">
    <div class="content">
      <div class="panel-text mlb-text font-size-14">
        {{ 'login.welcome.message' | translate }}
      </div>
      <fgb-tm-user-login></fgb-tm-user-login>
    </div>
  </div>
</div>

